﻿export enum UdViewStaticDataKey {
    Airport,
    Airspace,
    Airway,
    DrawingObjects,
    Fixes,
    FlightServiceStation,
    Holding,
    GridMora,
    LatLon,
    Navaids,
    Sids,
    Stars,
    Sua,
    TimeZone,
    WeatherStation,
    TerrainShading
}
